import AuthLayout from "./AuthLayout";
import DashboardLayout from "./DashboardLayout";

const PageLayouts = { AuthLayout, DashboardLayout };

export default PageLayouts;
